import React, {useContext, useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import {StyledBox} from "./FormAtoms";

export function RootTitle(props) {
  const {text} = props;
  return (
    <StyledBox>
      <Typography variant="subtitle1">{text}</Typography>
    </StyledBox>
  );
}
